import { getDefaultAsyncWrapperObj } from "@ane/core/lib/models";
import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import { messageCountLoadEpicReducer } from "./messageCount.duck.js";
import { convertMessages } from "../../../utils/CommonUtil.js";
import { reduxActionTypePrefix, reduxKeys } from "../constants/constants.js";
import MessagesResource from "../resources/Messages.resource.js";
const actionTypesPrefix = reduxActionTypePrefix + "/loadMessageList";
const messageListLoadEpicReducerArg = {
  actionPrefix: actionTypesPrefix,
  reduxKeyNested: () => [reduxKeys.items],
  loadResource: (request) => MessagesResource.getMessageList(request.workspaceId, request.loadCount, request.needNewMessage, request.lastMessageId),
  onCompleteSuccess: (resourcesResult, inputPayload) => convertMessages(resourcesResult),
  afterActionsOnSuccess: (inputPayload, outputPayload) => refreshCount(inputPayload, outputPayload)
};
const refreshCount = (inputPayload, outputPayload) => [
  messageCountLoadEpicReducer.actionCreators.load({
    workspaceId: inputPayload.workspaceId,
    lastMessageId: outputPayload.LastMessageId
  })
];
const messageListLoadEpicReducer = loadResourcesUtils(messageListLoadEpicReducerArg);
const messageListReducerStateDefault = {
  items: getDefaultAsyncWrapperObj()
};
const messageListReducer = (state = messageListReducerStateDefault, action) => {
  state = messageListLoadEpicReducer.reduxChange(state, action);
  return state;
};
export {
  messageListReducer as default,
  messageListLoadEpicReducer,
  messageListReducer,
  messageListReducerStateDefault
};
//# sourceMappingURL=messageList.duck.js.map
